import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getBaltimoreStructuredData() {
  const url = "https://restorehair.com/locations/maryland/baltimore/";
  const description =
    "Find out about your hair transplant options in Baltimore with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("baltimore", url, description),
    locationPageCrumbs(url, "Baltimore"),
  ];
}
